import { render, staticRenderFns } from "./IndexThreeAds.vue?vue&type=template&id=63b14b76&scoped=true"
import script from "./IndexThreeAds.vue?vue&type=script&lang=js"
export * from "./IndexThreeAds.vue?vue&type=script&lang=js"
import style0 from "./IndexThreeAds.vue?vue&type=style&index=0&id=63b14b76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b14b76",
  null
  
)

export default component.exports